import { z } from 'zod';
import {
  TenantIdSchema,
  UlidSchema,
  AlicuotaSchema,
  MetrosCuadradosSchema,
  IsoTimestampSchema,
} from './common.js';

/**
 * Unidad — bien inmueble bajo el condominio.
 * Incluye departamentos, estacionamientos, bodegas, locales comerciales.
 */

export const TipoUnidadSchema = z.enum([
  'vivienda',
  'estacionamiento',
  'bodega',
  'comercial',
  'oficina',
]);
export type TipoUnidad = z.infer<typeof TipoUnidadSchema>;

export const UnidadSchema = z.object({
  id: UlidSchema,
  tenantId: TenantIdSchema,
  /** Identificador visible dentro del condominio. Ej: "501", "E-12", "B-3". */
  numero: z.string().min(1).max(20),
  tipo: TipoUnidadSchema,
  m2: MetrosCuadradosSchema,
  alicuota: AlicuotaSchema,
  /** Número de dormitorios (solo aplica a vivienda). */
  dormitorios: z.number().int().min(0).max(20).optional(),
  /** Piso donde se ubica. Null para unidades sin piso aplicable. */
  piso: z.number().int().nullable().optional(),
  activo: z.boolean().default(true),
  createdAt: IsoTimestampSchema,
  updatedAt: IsoTimestampSchema,
});
export type Unidad = z.infer<typeof UnidadSchema>;

export const CreateUnidadRequestSchema = UnidadSchema.pick({
  numero: true,
  tipo: true,
  m2: true,
  alicuota: true,
  dormitorios: true,
  piso: true,
}).partial({ dormitorios: true, piso: true });
export type CreateUnidadRequest = z.infer<typeof CreateUnidadRequestSchema>;

/** PATCH: todos opcionales excepto que `tipo` no es editable. */
export const UpdateUnidadRequestSchema = CreateUnidadRequestSchema.omit({ tipo: true }).partial();
export type UpdateUnidadRequest = z.infer<typeof UpdateUnidadRequestSchema>;
